import { Alert, Button, Modal } from "react-bootstrap"

type ModalAlertProps = {
    content: string,
    contentTitle: string,
    variant: "danger" | "info",
    callback: () => void
}

export default function ModalAlert(props: ModalAlertProps) {
    return <Modal show={props.content !== undefined}><Modal.Body><Alert variant={props.variant}>
        {props.contentTitle}: {props.content}
    </Alert>
    </Modal.Body>
        <Modal.Footer>
            <Button variant="primary" onClick={props.callback} >OK</Button>
        </Modal.Footer>
    </Modal>
}